import { combineReducers } from '@ngrx/store';

import { flightResultsReducer as flightResults } from '@flight-results/store/reducers/flight-results.reducer';
import { selectedFlightsReducer as selectedFlights } from '@flight-results/store/reducers/selected-flights.reducer';
import {
  flightResultsDesktopReducer as flightResultsDesktop
} from '@flight-results/store/reducers/flight-results-desktop.reducer';
import { searchPayloadReducer as searchPayload } from '@flight-results/store/reducers/search-payload.reducer';
import { searchResultsDataReducer as searchResultsData } from '@flight-results/store/reducers/search-results-data.reducer';
import { UiFlightResultsRootReducer as ui } from '@flight-results/store/reducers/ui/index';
import { flightResultsMobileReducer as flightResultsMobile } from '@flight-results/store/reducers/flight-results-mobile.reducer';

import { flightResultsWidgetsReducer as flightResultsWidgets } from '@flight-results/store/reducers/flights-widgets.reducer';
import { flexDatesReducer as flexDates } from '@flight-results/store/reducers/flexible-dates.reducer';
import { flexDatesMappedReducer as flexDatesMapped } from '@flight-results/store/reducers/flexible-dates-mapped.reducer';
import { flightCabinSelectedReducer as flightCabinSelected } from '@flight-results/store/reducers/flight-cabin.reducer';
import {
  flightCabinDetailSelectedReducer as flightCabinDetailSelected
} from '@flight-results/store/reducers/flight-cabin-detail.reducer';
import {
  flightResultsMobileBySectorReducer as flightResultsMobileBySector
} from '@flight-results/store/reducers/flight-results-mobile-by-sector.reducer';

export const flightResultsRootReducer = combineReducers({
  flightResults,
  selectedFlights,
  flightResultsDesktop,
  flightResultsMobile,
  flightResultsMobileBySector,
  searchPayload,
  searchResultsData,
  ui,
  flightResultsWidgets,
  flexDates,
  flexDatesMapped,
  flightCabinSelected,
  flightCabinDetailSelected,
});
